<template>
  <div style="height: 100%">
    <div class="components-main" v-if="!islocking">
      <div class="anno_tit">
        <div class="fl">
          {{ $t("comments") }}
          <el-button
            size="mini"
            style="margin-left: 10px"
            @click="exportComments"
            >导出</el-button
          >
        </div>
        <div class="fr"><i class="el-icon-close" @click="close"></i></div>
      </div>
      <ul class="components-list">
        <li v-for="(item, i) in list" :key="i">
          <p class="list-head">
            <span style="float: left">{{ item.user.nickname }}</span>
            <i class="el-icon-delete" @click="removeCommentsData(item)"></i>
          </p>
          <div class="cover-img" @click="annotationGetImage(item)">
            <img :src="item.img" />
          </div>
          <p class="ms">{{ item.description }}</p>
          <p class="ms">批注时间：{{ item.update_time }}</p>
        </li>
      </ul>
    </div>
    <!--批注锁定-->
    <div class="annotation-lock" v-if="islocking">
      <div @click="exitLock">退出</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import documentUrl from "@/url/document";
import api from "@/url/api";

export default {
  name: "comments",
  props: ["commentsData"],
  data() {
    return {
      list: [],
      islocking: false,
    };
  },
  created() {
    this.getcommentsList();
  },
  methods: {
    //查询批注列表
    getcommentsList() {
      let _url = documentUrl.document_comments;
      let _data = {
        file_id: this.commentsData.rowId,
        sort: "-create_time",
      };
      axios.get(_url, { params: _data }).then((res) => {
        if (res.data.code == 200) {
          res.data.data.map((item) => {
            item.img = `${api.img_base_url.url}${item.img}`;
          });
          this.list = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    close() {
      this.$emit("colseCommentsList");
    },
    //删除批注
    removeCommentsData(item) {
      console.log(item);
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let _url = documentUrl.document_comments;
          let _data = { delete_ids: [item.id] };
          axios.delete(_url, { data: _data }).then((res) => {
            if (res.data.code == 200) {
              this.getcommentsList();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    //批注定位
    annotationGetImage(item) {
      this.commentsData.viewer2D.render();
      const data = JSON.parse(item.status);
      var config =
        new Glodon.Bimface.Plugins.Annotation.AnnotationToolbarConfig();
      config.viewer = this.commentsData.viewer2D;
      var annotationToolbar =
        new Glodon.Bimface.Plugins.Annotation.AnnotationToolbar(config);
      this.commentsData.modelViewer.annotationToolbar = annotationToolbar;
      this.commentsData.modelViewer.annotationmanager =
        annotationToolbar.getAnnotationManager();
      this.commentsData.modelViewer.annotationmanager.setState(data);
      this.commentsData.modelViewer.annotationmanager.showAnnotation();
      $("#domId").find(".bf-toolbar-bottom").hide();
      this.islocking = true;
    },
    //退出批注
    exitLock() {
      $("#domId").find(".bf-toolbar-bottom").show();
      this.islocking = false;
      this.commentsData.modelViewer.annotationmanager.endDrawing &&
        this.commentsData.modelViewer.annotationmanager.endDrawing();
    },
    //导出批注
    exportComments() {
      let _url = documentUrl.document_comments + "/export";
      let _data = {
        file_id: this.commentsData.rowId,
      };
      axios.get(_url, { params: _data, responseType: "blob" }).then((res) => {
        this.downloadFileStream(res.data, "批注.docx");
      });
    },
    //下载文件流
    downloadFileStream(data, name) {
      let blob = new Blob([data], { type: `application/docx;charset=utf-8` });
      let downloadElement = document.createElement("a");
      let href = window.URL.createObjectURL(blob);
      downloadElement.href = href;
      downloadElement.download = name;
      document.body.appendChild(downloadElement);
      downloadElement.click();
      document.body.removeChild(downloadElement);
      window.URL.revokeObjectURL(href);
    },
  },
};
</script>

<style scoped>
.components-main {
  height: 100%;
  overflow: auto;
  border: 1px solid #ccc;
  border-bottom: none;
  background: #f5f5f5;
}
.anno_tit {
  height: 40px;
  border-bottom: 1px solid #ccc;
  padding: 0 10px;
  line-height: 40px;
}
.anno_tit .fr {
  cursor: pointer;
}
.components-list {
  padding: 10px;
}
.components-list li {
  padding: 20px;
  background: #fff;
  border: solid 1px #ccc;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  border-radius: 4px;
  margin-bottom: 10px;
}
.components-list li .list-head {
  text-align: right;
}
.components-list li .list-head i {
  cursor: pointer;
}
.components-list li .cover-img {
  height: 190px;
  overflow: hidden;
}
.components-list li .cover-img img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}
.components-list li .ms {
  margin-top: 5px;
  font-size: 12px;
}
.annotation-lock {
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
}
.annotation-lock div {
  border: 1px solid #333;
  background-color: rgba(0, 0, 0, 0.8);
  position: absolute;
  left: 50%;
  bottom: 10px;
  transform: translate(-50%);
  padding: 10px 15px;
  width: 100px;
  text-align: center;
  color: #fff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/documentManagement/assembly/comments.vue